import { render, staticRenderFns } from "./PageSolvency.vue?vue&type=template&id=220868de"
import script from "./PageSolvency.vue?vue&type=script&lang=js"
export * from "./PageSolvency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports